import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { Form, Input, Button,Spin,Card,DatePicker,Select,message, Divider } from 'antd';
import { UserOutlined,DropboxOutlined,LockOutlined,MessageFilled, LoadingOutlined,RightCircleFilled, PhoneFilled, PhoneOutlined, MessageOutlined, MailOutlined, BankOutlined } from '@ant-design/icons';
import axios from 'axios'
import * as serverconfig from '../../serverconn'
import { Layout, Menu, Breadcrumb,Carousel,Tabs,Collapse,Image,Drawer } from 'antd';
import {
  Col,
  Row,
} from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import { MdHome, MdList, MdSearch, MdShoppingCart } from 'react-icons/md';
import moment from 'moment';
import TrackingGraph from './TrackingGraph';
import TrackingTable from './TrackingTable';
import SamplesChart from './SamplesChart';
import CentralHubChart from './CentralHubChart';

var CryptoJS = require("crypto-js");

const { Header, Content, Footer } = Layout;

const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const { TabPane } = Tabs;
const { Panel } = Collapse;
const { Meta } = Card;
const { Option } = Select;
const { RangePicker } = DatePicker;
const FormItem=Form.Item;
const dateFormat = 'DD/MM/YYYY';


const GraphsComponent = () => {

  const [isMobile, setIsMobile] = useState(false);
  const [datarequested, setdatarequested] = useState(false);

  const [dateone, setdateone] = useState('');
  const [datetwo, setdatetwo] = useState('');
  const [districts, setdistricts] = useState([]);
  const [district, setdistrict] = useState('');

  const [regions, setregions] = useState([]);
  const [region, setregion] = useState('');

  const [hubs, sethubs] = useState([]);
  const [hub, sethub] = useState('');


  const [tracking_hubs_report, settracking_hubs_report] = useState([]);
  const [non_tracking_hubs_report, setnon_tracking_hubs_report] = useState([]);

  const [delivered_to_hubs_list, setdelivered_to_hubs_list] = useState([]);
  const [total_samples_delivered_to_hubs, settotal_samples_delivered_to_hubs] = useState(0);

  const [delivered_to_centralhub_list, setdelivered_to_centralhub_list] = useState([]);
  const [total_samples_delivered_to_centralhub, settotal_samples_delivered_to_centralhub] = useState(0);

  // Function to check if the screen size is mobile
  const checkIsMobile = () => {
    setIsMobile(window.innerWidth < 768); // Adjust breakpoint as needed
  };

  useEffect(() => {
    // Check initial screen size
    checkIsMobile();
    //get date
    load_initdata()
    // Add event listener for screen resize
    window.addEventListener('resize', checkIsMobile);
    // Cleanup
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);



  //loan initial data
  const load_initdata=()=>{

    //get the dates now
    
    setdateone(getLastWeekMondayToToday().lastWeekMonday)
    setdatetwo(getLastWeekMondayToToday().today)


    let form_data1 = new FormData();
    //Now submit sale data to database
    axios.post(serverconfig.backendserverurl+'/customqueries/get_regions', 
    form_data1,{
    headers: {
      'content-type': 'multipart/form-data'
    }
    })
    .then(res =>{
      setregions(res.data.report)
    }).catch(error => console.log(error))   


    let form_data2 = new FormData();
    form_data2.append('district', district); // Initially no region selected
    
    //Now submit sale data to database
    axios.post(serverconfig.backendserverurl+'/customqueries/get_hubs', 
    form_data2,{
    headers: {
      'content-type': 'multipart/form-data'
    }
    })
    .then(res =>{
      sethubs(res.data.report)
    }).catch(error => console.log(error))   


    let form_data = new FormData();
    form_data.append('region', region);
    //Now submit sale data to database
    axios.post(serverconfig.backendserverurl+'/customqueries/get_districts', form_data,{
    headers: {
      'content-type': 'multipart/form-data'
    }
    })
    .then(res =>{
      setdistricts(res.data.report)
     // setdatarequested(false)
    } 
    )
    .catch(error => console.log(error))   

    //load initial data
    get_hubs_data(getLastWeekMondayToToday().lastWeekMonday,getLastWeekMondayToToday().today)


  }



  //get dates
  const getLastWeekMondayToToday=()=> {
    const today = new Date();
  
    const day = today.getDay();
    const mondayIndex = (day + 6) % 7;
  
    const thisWeekMonday = new Date(today);
    thisWeekMonday.setDate(today.getDate() - mondayIndex);
  
    const lastWeekMonday = new Date(thisWeekMonday);
    lastWeekMonday.setDate(thisWeekMonday.getDate() - 7);
  
    const formatDate = (date) => {
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const yyyy = date.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    };
  
    return {
      lastWeekMonday: formatDate(lastWeekMonday),
      today: formatDate(today)
    };


  }


  //get initial data
  const get_hubs_data=(date1,date2)=>{
    let form_data = new FormData();
    form_data.append('dateone', date1);
    form_data.append('datetwo', date2);

    form_data.append('region', region);
    form_data.append('district', district);
    form_data.append('hub', hub);

    setdatarequested(true)
    //Now submit sale data to database
    axios.post(serverconfig.backendserverurl+'/customqueries/get_hubs_visited_statistics', form_data,{
    headers: {
      'content-type': 'multipart/form-data'
    }
    })
    .then(res =>{
        settracking_hubs_report(res.data.tracking_hubs_report)
        setnon_tracking_hubs_report(res.data.non_tracking_hubs_report)

        //set total samples delivered to hubs
        settotal_samples_delivered_to_hubs(res.data.total_samples_delivered_to_hubs)
        settotal_samples_delivered_to_centralhub(res.data.total_samples_delivered_to_centralhub)

        setdelivered_to_hubs_list(res.data.delivered_to_hubs_list)
        setdelivered_to_centralhub_list(res.data.delivered_to_centralhub_list)

        setdatarequested(false)
    })
    .catch(error => console.log(error))   
  
  }

 
    if(datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
            <Spin size="large">
            <div className="content">
              <h3>Umoja public tracker</h3>
            </div>
            </Spin> 
       </div>
      )
    }else{
      return (
        <div style={{display: 'flex', flexDirection: 'column', justifyContent:'flex-start', margin: 20}}>
          <h4 style={{fontWeight:'bolder',margin:10}}>FILTER HERE</h4>
            {/**Start of search form */}

               <Form layout="inline"  style={{margin:6}}>
              
                <FormItem label="">
                  <RangePicker 
                  placeholder={["From:"+dateone,"To:"+datetwo]}
                  
                  onChange={(date, dateString) =>{
                    setdateone(dateString[0])
                    setdatetwo(dateString[1])
                  }} format={dateFormat} />
                </FormItem>


                <FormItem label="">
                  <Select 
                  placeholder="Region" 
                  value={region} 
                  onChange={(val)=>{
                    setregion(val)

                    //lets get districts for this region
                        let form_data = new FormData();
                        form_data.append('region', val);
                        //Now submit sale data to database
                        axios.post(serverconfig.backendserverurl+'/customqueries/get_districts', form_data,{
                        headers: {
                          'content-type': 'multipart/form-data'
                        }
                        })
                        .then(res =>{
                          setdistricts(res.data.report)
                         // setdatarequested(false)
                        } 
                        )
                        .catch(error => console.log(error))  
                  
                  
                  }} 
                  showSearch
                  optionFilterProp="children"
                  >
                    <Option value={''}>Region</Option>
                    {regions.map(
                      (itm)=>(
                        <Option value={itm.name}>{itm.name}</Option>
                      ))}
                  </Select>
                </FormItem>



                <FormItem label="">
                  <Select 
                  placeholder="District" 
                  value={district} 
                  onChange={(val)=>{
                    setdistrict(val)
                  
                      let form_data2 = new FormData();
                      form_data2.append('district', val); // Initially no region selected
                      
                      //Now submit sale data to database
                      axios.post(serverconfig.backendserverurl+'/customqueries/get_hubs', 
                      form_data2,{
                      headers: {
                        'content-type': 'multipart/form-data'
                      }
                      })
                      .then(res =>{
                        sethubs(res.data.report)
                      }).catch(error => console.log(error))  
                  
                  
                  }} 
                  showSearch
                  optionFilterProp="children"
                  >
                    <Option value={''}>District</Option>
                    {districts.map(
                      (dist)=>(
                        <Option value={dist.district_name}>{dist.district_name}</Option>
                      ))}
                  </Select>
                </FormItem>


                <FormItem label="">
                  <Select 
                  placeholder="Hub" 
                  value={hub} 
                  onChange={(val)=>{sethub(val)}} 
                  showSearch
                  optionFilterProp="children"
                  >
                    <Option value={''}>Hub</Option>
                    {hubs.map(
                      (itm)=>(
                        <Option value={itm.name}>{itm.name}</Option>
                      ))}
                  </Select>
                </FormItem>



                <FormItem style={{marginTop:5}}>
                <Button 
                  icon={<MdSearch/>}
                  onClick={()=>{
                    get_hubs_data(dateone,datetwo)

                }} type="primary" htmlType="button">Search</Button>
                </FormItem> 

              </Form>
            {/**End of search form */}
            
            <Divider></Divider>

            {/**Tabs */}
            <Tabs>

             {/**Tracking */}   
            <TabPane tab={tracking_hubs_report.length+" HUBS TRACKING"} key="01" >
              <Tabs tabPosition='bottom'>

                <TabPane  tab={'Statistical Data'} key="01" >
                  <TrackingGraph tracking_hubs_report={tracking_hubs_report} />
                </TabPane>

                <TabPane tab={'View Tabular Data'} key="02" >
                   <TrackingTable tracking_hubs_report={tracking_hubs_report} />
                </TabPane>
              </Tabs>

            </TabPane>

              {/**Non Tracking */}   
              <TabPane tab={non_tracking_hubs_report.length+" HUBS NOT TRACKING"} key="02" >
              <TrackingTable tracking_hubs_report={non_tracking_hubs_report} />
              </TabPane>


            <TabPane tab={total_samples_delivered_to_hubs+" Samples DELIVERED AT HUBS"} key="04" >
              <h3 style={{fontWeight:'bolder',margin:10,display:'flex',justifyContent:'center'}}>VOLUME OF SAMPLES DELIVERED TO HUBS</h3>
              <SamplesChart 
                delivered_to_hubs_list={delivered_to_hubs_list} 
                datarequested={datarequested}
              />
            </TabPane>

            <TabPane tab={total_samples_delivered_to_centralhub+" Samples DELIVERED TO CENTRAL HUB"} key="05" >
               <h3 style={{fontWeight:'bolder',margin:10,display:'flex',justifyContent:'center'}}>VOLUME OF SAMPLES DELIVERED TO CENTRAL HUB</h3>

              <CentralHubChart 
                delivered_to_centralhub_list={delivered_to_centralhub_list} 
                datarequested={datarequested}
              />
            </TabPane>

          </Tabs>
       </div>
       );
    }

}


export default GraphsComponent;
